var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5208 7C49.4687 7 36.4409 20.0307 36.4409 36.0799C36.4409 52.1349 49.4687 65.1598 65.5208 65.1598C81.602 65.1598 94.6007 52.1349 94.6007 36.0799C94.6007 20.0307 81.602 7 65.5208 7Z",
    fill: "url(#paint0_linear_6726_88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5208 7C49.4687 7 36.4409 20.0307 36.4409 36.0799C36.4409 52.1349 49.4687 65.1598 65.5208 65.1598C81.602 65.1598 94.6007 52.1349 94.6007 36.0799C94.6007 20.0307 81.602 7 65.5208 7Z",
    fill: "url(#paint1_radial_6726_88)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1072 13.4543C20.624 13.4543 4 30.082 4 50.5614C4 71.0483 20.624 87.6686 41.1072 87.6686C61.6275 87.6686 78.2144 71.0483 78.2144 50.5614C78.2144 30.082 61.6275 13.4543 41.1072 13.4543Z",
    fill: "#B6CAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1072 12.9543C20.3478 12.9543 3.5 29.8059 3.5 50.5614C3.5 71.3245 20.3479 88.1686 41.1072 88.1686C61.9039 88.1686 78.7144 71.3242 78.7144 50.5614C78.7144 29.8062 61.904 12.9543 41.1072 12.9543Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6726_88",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 12,
    width: 77,
    height: 77
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1072 13.4543C20.624 13.4543 4 30.082 4 50.5614C4 71.0483 20.624 87.6686 41.1072 87.6686C61.6275 87.6686 78.2144 71.0483 78.2144 50.5614C78.2144 30.082 61.6275 13.4543 41.1072 13.4543Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1072 12.9543C20.3478 12.9543 3.5 29.8059 3.5 50.5614C3.5 71.3245 20.3479 88.1686 41.1072 88.1686C61.9039 88.1686 78.7144 71.3242 78.7144 50.5614C78.7144 29.8062 61.904 12.9543 41.1072 12.9543Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6726_88)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6726_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5208 7C49.4687 7 36.4409 20.0307 36.4409 36.0799C36.4409 52.1349 49.4687 65.1598 65.5208 65.1598C81.602 65.1598 94.6007 52.1349 94.6007 36.0799C94.6007 20.0307 81.602 7 65.5208 7Z",
    fill: "#5A92FF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6726_88)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.25 70.75C44.25 72.5449 42.7949 74 41 74C39.2051 74 37.75 72.5449 37.75 70.75V70.6786C37.75 68.8836 39.2051 67.4286 41 67.4286C42.7949 67.4286 44.25 68.8836 44.25 70.6786V70.75ZM50.9775 48.5357L48.0525 51.5586C46.3059 53.3489 45.0482 54.9012 44.5226 57.6229C44.1823 59.3853 42.7949 60.8571 41 60.8571C39.2051 60.8571 37.7096 59.3939 37.9574 57.6161C38.3552 54.7618 39.3856 52.1368 41.5525 49.9157L45.5825 45.7757C46.785 44.5929 47.5 42.95 47.5 41.1429C47.5 37.5286 44.575 34.5714 41 34.5714C38.2398 34.5714 35.867 36.3343 34.9289 38.8013C34.459 40.0368 33.4285 41.1429 32.1067 41.1429C29.8386 41.1429 27.9364 39.2606 28.6261 37.1C30.3119 31.8182 35.2129 28 41 28C48.1825 28 54 33.8814 54 41.1429C54 44.0343 52.83 46.6629 50.9775 48.5357Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.622 48.1841L50.622 48.1841L50.6182 48.188L47.6946 51.2094C47.6944 51.2096 47.6941 51.2099 47.6939 51.2101C45.923 53.0254 44.5848 54.6639 44.0317 57.5281C43.7241 59.121 42.4942 60.3571 41 60.3571C39.4555 60.3571 38.2537 59.1118 38.4526 57.6852C38.8392 54.9111 39.8341 52.3932 41.9104 50.2649L41.9108 50.2645L45.9371 46.1283C47.2325 44.8519 48 43.0823 48 41.1429C48 37.2576 44.8563 34.0714 41 34.0714C38.0214 34.0714 35.4695 35.9728 34.4615 38.6236C34.0259 39.7691 33.1283 40.6429 32.1067 40.6429C31.1071 40.6429 30.2011 40.2271 29.6273 39.5955C29.0617 38.9728 28.8174 38.1449 29.1024 37.252C30.7249 32.1686 35.4396 28.5 41 28.5C47.9012 28.5 53.5 34.1524 53.5 41.1429C53.5 43.8981 52.3851 46.4016 50.622 48.1841ZM43.75 70.75C43.75 72.2688 42.5188 73.5 41 73.5C39.4812 73.5 38.25 72.2688 38.25 70.75V70.6786C38.25 69.1598 39.4812 67.9286 41 67.9286C42.5188 67.9286 43.75 69.1598 43.75 70.6786V70.75Z",
    stroke: "white",
    strokeOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6726_88",
    x: 16.4409,
    y: -13,
    width: 98.1599,
    height: 98.1598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_6726_88"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6726_88",
    x: 23.4827,
    y: 23,
    width: 45.5173,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0553693 0 0 0 0 0.264751 0 0 0 0 0.80316 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6726_88"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6726_88",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6726_88",
    x1: 59,
    y1: 42,
    x2: 87,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C57F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6726_88",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.5 33) rotate(-40.6013) scale(18.4391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4440FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405EFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.2e1d0832.svg";
export { ForwardRef as ReactComponent };